<template>
  <vue-frappe
    v-if="ttfbValues.length"
    id="sitedetail-ttfbs"
    :title="$t('site.ttfb')"
    type="line"
    :labels="ttfbLabels"
    :height="200"
    :colors="['#1e90ff']"
    :lineOptions="{regionFill: 1, hideDots: 1}"
    :data-sets="[{name: $t('site.ttfb'), values: ttfbValues}]"
    :axis-options="{xAxisMode: 'tick'}"
    :tooltip-options="{formatTooltipY: d => d + ' ms'}"
  ></vue-frappe>
</template>

<script>

import { mapState } from 'vuex'

import moment from 'moment'

export default {

  name: 'TtfbSection',

  computed: {
    ...mapState('site', [
      'siteDetail'
    ]),

    ...mapState('user', [
      'userTimezone'
    ]),

    ttfbLabels () {
      if (typeof this.siteDetail.data.ttfbs === 'undefined') {
        return []
      }

      return this.siteDetail.data.ttfbs.map((e) => {
        return moment(e.datetime * 1000).add(parseInt(this.userTimezone), 'hours').format('DD.MM HH:mm')
      })
    },

    ttfbValues () {
      if (typeof this.siteDetail.data.ttfbs === 'undefined') {
        return []
      }

      return this.siteDetail.data.ttfbs.map((e) => {
        return e.value
      })
    }
  }
}
</script>
